export default "__VITE_ASSET__DLTi6LRk__"